import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Card, Col, Container, Row, Spinner } from "react-bootstrap";
import Contactus from "./Contact";
import Domainpage from "./Dapa";
import Seoinspect from "./Seoinspect";
import { Link } from "react-router-dom";
import Trialcards from "./Trial";
import Nav from "./Navbar";
import Main from "./Main";
import Footer from "./Footer";
import { FaCheck } from "react-icons/fa";
import { BASE_URL_API_TRANXT_UAT_API } from "../Utils/Constant";
import ChatWidget from "./ChatBot";
import Ai from "./Ai";
import Siteblog from "./Siteblog";
import Sitefaq from "./Sitefaq";
import Topconnection from "./Topconnection";
const First = () => {
  return (
    <div>
      <Nav />
      <Container fluid className="p-0" style={{ overflowX: "hidden" }}>
        <Main />

        <Trialcards />
        <div
          className="  p-4 "
          style={{
            background:
              "linear-gradient(to right, #AFDDFF 0%, #C5E7FF 30%, #DAF0FF 60%, #EDF8FF 85%, #FFFFFF 100%)",marginTop:"7rem"
          }}
        >
          <h2
            style={{ color: "#0A3981" }}
            className="d-flex justify-content-center pt-5"
          >
            <b> Check Your Domain Authority and Age Instantly</b>
          </h2>
          <Domainpage />
        </div>
        <Row className="d-flex justify-content-center  "  style={{
           marginTop:"5rem"
          }}>
          <Col md={10}>
            <h1
              style={{
                // fontFamily: "'Playfair Display', serif",
                fontSize: "2.5rem",
              }}
              className="mt-2 mb-5 text-center"
            >
              <b>Plans & Pricing</b>
            </h1>

            <Pricingcard />
          </Col>
        </Row>
        <Row className="d-flex justify-content-center mt-md-5 mt-2 mb-md-5 mb-2  mx-1">
          <Col md={10}>
            <Topconnection />
          </Col>
        </Row>
        <Ai />
        <Row className="d-flex justify-content-center mt-md-5 mt-2 mb-md-5 mb-2  mx-1">
          <Col md={10}>
            <Siteblog />
          </Col>
        </Row>
        <Row className="d-flex justify-content-center mt-md-5 mt-2 mb-md-5 mb-2  mx-1">
          <Col md={10}>
            <Sitefaq />
          </Col>
        </Row>
        <Contactus />

        <div
          data-section="Footer"
          className=" p-0 "
          style={{
            overflow: "hidden",
            background: "#31393C",
            borderTopRightRadius: "2rem",
            borderTopLeftRadius: "2rem", marginTop:"6rem"
          }}
        >
          <Footer />
        </div>
      </Container>
      <ChatWidget />
    </div>
  );
};

const Pricingcard = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    GetPricingPlans();
  }, []);

  const GetPricingPlans = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Seo/GetPricingPlans`,
        // "https://apiuat.seobix.com/api/Seo/GetPricingPlans",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch SEO data.");
      }

      const data = await response.json();
      if (data.status === "0" && data.data) {
        const formattedPlans = data.data.map((plan) => ({
          name: plan.plan_name,
          price: plan.amount,
          duration: plan.duration,
          description: plan.desc1,
          features1: plan.features1,
          features2: plan.features2,
          features3: plan.features3,
          features4: plan.features4,
          heading: plan.heading,
          desc2: plan.desc2,
          features: plan.data.map((feature) => ({
            text: feature.description,
            video: feature.video_url || null,
          })),
          buttonText: "More Details",
        }));

        setPlans(formattedPlans);
      }
    } catch (error) {
      console.error("Error fetching SEO data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading ? (
        <div className="text-center my-5">
          <img src={require("../Images/loader.gif")} alt="seobix" />
        </div>
      ) : (
        <>
          <Row className="justify-content-center mx-1">
            {plans.map((plan, index) => (
              <Col key={index} md={6} lg={4} className="mb-4">
                <Card className="shadow-sm h-100">
                  <Card.Body className="p-4">
                    <h5 className="mb-1">
                      <b>{plan.name}</b>
                    </h5>
                    <h3>
                      <b>{plan.price}</b>/
                      <span style={{ fontSize: "1rem" }}>{plan.duration}</span>
                    </h3>
                    <Link
                      to="/pricing-plans"
                      style={{ textDecoration: "none", color: "#fff" }}
                    >
                      {" "}
                      <Button className="mt-2 mb-2" style={{ width: "100%" }}>
                        {plan.buttonText}
                      </Button>
                    </Link>
                    <p className="text-muted mb-2 mt-3">
                      <b>{plan.description}</b>
                    </p>
                    <p>
                      <FaCheck style={{ color: "green" }} /> &nbsp; &nbsp;
                      {plan.features1}
                    </p>
                    <p>
                      <FaCheck style={{ color: "green" }} /> &nbsp; &nbsp;
                      {plan.features2}
                    </p>
                    <p>
                      <FaCheck style={{ color: "green" }} /> &nbsp; &nbsp;
                      {plan.features3}
                    </p>
                    <p>
                      <FaCheck style={{ color: "green" }} /> &nbsp; &nbsp;
                      {plan.features4}
                    </p>
                    <h6>
                      <b>{plan.heading}</b>
                    </h6>
                    <p
                      className="text-muted mb-2 mt-3"
                      style={{ fontWeight: "500" }}
                    >
                      {plan.desc2}
                    </p>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </>
      )}
    </>
  );
};
export default First;
